import * as types from './actionTypes';

export const fetchTimesheetApprovalsRequest = (payload) => ({
  type: types.FETCH_TIMESHEET_APPROVALS_REQUEST,
  payload,
});

export const fetchTimesheetEmployeeDetailsRequest = (payload) => ({
  type: types.FETCH_TIMESHEET_EMPLOYEE_DETAILS_REQUEST,
  payload,
});

export const updateTimesheetApprovalRequest = (payload) => ({
  type: types.UPDATE_TIMESHEET_APPROVAL_REQUEST,
  payload,
});

export const resetTimesheetEmployeeApprovals = () => ({
  type: "RESET_TIMESHEET_EMPLOYEE_APPROVALS",
  payload:[]
});

export const fetchTimesheetHRApprovalRequest = (payload) => ({
  type: types.FETCH_TIMESHEET_HR_APPROVAL_REQUEST,
  payload,
});

export const generateTimesheetHRApprovalRequest = (payload) => ({
  type: types.GENERATE_TIMESHEET_HR_APPROVAL_REQUEST,
  payload,
});

export const saveGeneratedTimesheetHRApprovalRequest = (payload) => ({
  type: types.SAVE_GENERATED_TIMESHEET_HR_APPROVAL_REQUEST,
  payload,
});

export const resetTimesheetHRApprovals = () => ({
  type: types.RESET_TIMESHEET_HR_APPROVALS,
});

export const fetchTimesheetFinalApproval = (payload) => ({
  type: types.FETCH_TIMESHEET_FINAL_APPROVAL_REQUEST,
  payload,
});

export const saveTimesheetFinalApproval = (payload) => ({
  type: types.SAVE_TIMESHEET_FINAL_APPROVAL_REQUEST,
  payload,
});

export const resetTimesheetFinalApproval = () => ({
  type: types.RESET_TIMESHEET_FINAL_APPROVAL,
});